<template>
  <div>
    <div v-if="! isDisabled">
      <FileDropzone 
        :uuid="uuid" 
        :category="category"
        :allowedTypes="allowedTypes" />
    </div>
    <div v-if="files.length !== 0">
      <FileList 
        v-if="view === 'list'" 
        :files="files"
        :wide="wide"
        :linklabel="linklabel"
        :disabled="isDisabled"
        :filenameprefix="filenameprefix"
        @disconnect="handleDisconnectFile"
      />
      <FileThumbnails
        v-if="view === 'thumbnails'" 
        :files="files"
        :wide="wide" 
        :linklabel="linklabel"
        :disabled="isDisabled"
        :filenameprefix="filenameprefix"
        @disconnect="handleDisconnectFile"
      />
    </div>
  </div>
</template>

<script>

import FileDropzone from '@/components/files/FileDropzone.vue'
import FileList from '@/components/files/FileList.vue'
import FileThumbnails from '@/components/files/FileThumbnails.vue'

import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'FilesManager',
  components: {
    FileThumbnails,
    FileDropzone,
    FileList
  },
  props: {
    uuid: {
      type: String,
      required: true
    },
    category: {
      type: String,
      required: true
    },
    locked: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: true
    },
    view: {
      type: String,
      default: 'list'
    },
    wide: {
      type: Boolean,
      default: false
    },
    linklabel: {
      type: String,
      default: null
    },
  },
  computed: {
    ...mapGetters('realisation',[
      'recordByUuid'
    ]),
    isDisabled() {
      return !! (this.locked || this.disabled)
    },
    record() {
      return this.recordByUuid({
        uuid: this.uuid
      })
    },
    files() {
      return this.record.getFileDataByCategory({
        category: this.category
      })
    },
    /**
     * When showing previews of files, we do not accept .pdf files
     */
    allowedTypes() {
      return this.view === 'thumbnails'
        ? ['image/jpg', 'image/jpeg', 'image/png']
        : ['image/jpg', 'image/jpeg', 'image/png', 'application/pdf']
    },
    filenameprefix() {
      let category = this.category

      // Translate category to old Doc category names ... 
      const oldCategories = {
        parkingspots: 'ParkingSpots',
        topview: 'TopView',
        sideview: 'SideView',
        'topview-alt': 'TopViewAlt',
        'sideview-alt': 'SideViewAlt',
        trafficdecision: 'TrafficDecision',
        deliverydocumentation: 'DeliveryDocumentation',
        underground: 'Underground',
        broker: 'Broker',
        gridoperator: 'GridOperator',
        cpoadditional: 'CPOAdditional'
      }
      category = oldCategories[category] || category

      return `${this.record.getCaseRef()}-${category}`
    }
  },
  methods: {
    ...mapMutations('realisation', [
      'replaceRecord',
    ]),
    handleDisconnectFile: async function({ uuid }) {
      const response = await this.$cbapi.files.disconnectFileFromProcess({
        processUuid: this.uuid,
        fileUuid: uuid,
        synced: this.record.getSyncedTS()
      })

      if (response) {
        this.replaceRecord({
          record: response?.data,
        })

        this.$notify({
          success: true,
          title: 'Succes',
          text: `Het bestand is losgekoppeld en de realisatie proces data is opnieuw ingeladen.`
        })
      }
    }
  }
}
</script>

